var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 18,
    viewBox: "0 0 8 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33332 17.3333V11.5H0.666656V6.49996C0.666656 6.04163 0.82999 5.6494 1.15666 5.32329C1.48332 4.99718 1.87555 4.83385 2.33332 4.83329H5.66666C6.12499 4.83329 6.51749 4.99663 6.84416 5.32329C7.17082 5.64996 7.33388 6.04218 7.33332 6.49996V11.5H5.66666V17.3333H2.33332ZM3.99999 3.99996C3.54166 3.99996 3.14943 3.8369 2.82332 3.51079C2.49721 3.18468 2.33388 2.79218 2.33332 2.33329C2.33332 1.87496 2.49666 1.48274 2.82332 1.15663C3.14999 0.830515 3.54221 0.667182 3.99999 0.666626C4.45832 0.666626 4.85082 0.829959 5.17749 1.15663C5.50416 1.48329 5.66721 1.87551 5.66666 2.33329C5.66666 2.79163 5.5036 3.18413 5.17749 3.51079C4.85138 3.83746 4.45888 4.00051 3.99999 3.99996Z",
    fill: "#72737F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan);
export default __webpack_public_path__ + "static/media/man.baba9f6e574815a4c21137e398936cec.svg";
export { ForwardRef as ReactComponent };